<div class="promotion-hero">
  <div class="promotion-img">
    <img src="/assets/images/wallet.svg" alt="Wallet" />
  </div>
  <h2 class="ds-title-1">{{ 'ACCOUNT.promotion.title' | translate }}</h2>
  @if (vm.promo.referralMoneyMonthsDuration) {
    <p
      class="ds-running-1 ds-color-core-neutral-10"
      [innerHTML]="
        'ACCOUNT.promotion.subtitle.money'
          | translate: { amount: vm.promo.referralMoneyMoneyMonthly * vm.promo.referralMoneyMonthsDuration | thousand: vm.currency }
      "
    ></p>
  } @else {
    <p
      class="ds-running-1 ds-color-core-neutral-10"
      [innerHTML]="'ACCOUNT.promotion.subtitle.months' | translate: { months: vm.promo.referralMonths }"
    ></p>
  }
  <p
    class="ds-running-3 ds-color-core-neutral-7"
    [innerHTML]="
      'ACCOUNT.promotion.earned.money' | translate: { people: vm.promo.people, earnedAmount: vm.promo.earnedAmount | thousand: vm.currency }
    "
  ></p>
</div>

<div class="promotion-share">
  <p class="ds-running-3 ds-color-core-neutral-7">{{ 'ACCOUNT.promotion.invite.label' | translate }}</p>
  <div class="ds-card">
    <div class="promotion-code" (click)="onCopyToClipboard('code')">
      <h2 class="ds-title-2">{{ vm.referralCode }}</h2>
      <p class="ds-running-3 ds-color-core-neutral-7" [ngStyle]="vm.language === 'fr-CH' && { 'max-width': '80px', 'text-align': 'center' }">{{
        'ACCOUNT.promotion.invite.copyCta' | translate
      }}</p>
    </div>
  </div>
  <app-ds-button variant="primary" type="button" (click)="onInviteFriends(vm.promo, vm.currency, vm.referralCode)">{{
    'ACCOUNT.promotion.invite.btn' | translate
  }}</app-ds-button>
  <p class="promotion-link ds-running-3 ds-color-core-neutral-7" (click)="onCopyToClipboard('link')">
    <app-ds-icon
      style="display: inline-block; margin-top: 2px; vertical-align: top"
      color="var(--color-core-neutral-7)"
      size="icon-size-0"
      name="link"
    ></app-ds-icon>
    app.inyova.{{ vm.appLocation }}/invite/<strong>{{ vm.referralCode }}</strong>
  </p>
  @if (vm.showRedeemLink) {
    <p class="promotion-redeem ds-running-3 ds-color-core-neutral-7" (click)="onShowPromotionsModal()">
      <a class="ds-color-core-neutral-7" href="javasript:;">{{
        (vm.showRedeemLink === 'step_5' ? 'modals.promotions.h2' : 'modals.promotions-referrals.h2-both') | translate
      }}</a>
    </p>
  }
</div>

<div class="promotion-todo">
  <h2 class="ds-heading-1">{{ 'ACCOUNT.promotion.flow.heading' | translate }}</h2>

  <div>
    <div class="promotion-todo-item">
      <app-ds-rounded-icon variant="custom" icon="share-2" [customColor]="'var(--color-core-brand-2-2)'"></app-ds-rounded-icon>
      <div class="promotion-todo-content">
        <p class="ds-heading-3 ds-color-core-neutral-10">{{ 'ACCOUNT.promotion.flow.step1.title' | translate }}</p>
        <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'ACCOUNT.promotion.flow.step1.desc' | translate }}</p>
      </div>
    </div>

    <div class="promotion-todo-item">
      <app-ds-rounded-icon variant="custom" icon="user-round-pen" [customColor]="'var(--color-core-brand-6-2)'"></app-ds-rounded-icon>
      <div class="promotion-todo-content">
        <p class="ds-heading-3 ds-color-core-neutral-10">{{ 'ACCOUNT.promotion.flow.step2.title' | translate }}</p>
        <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'ACCOUNT.promotion.flow.step2.desc' | translate }}</p>
      </div>
    </div>

    <div class="promotion-todo-item">
      <app-ds-rounded-icon variant="custom" icon="gift" [customColor]="'var(--color-core-brand-4-3)'"></app-ds-rounded-icon>
      <div class="promotion-todo-content">
        <p class="ds-heading-3 ds-color-core-neutral-10">{{ 'ACCOUNT.promotion.flow.step3.title' | translate }}</p>
        <p class="ds-ui-2 ds-color-core-neutral-8">
          {{
            (vm.promo.referralMoneyMonthsDuration ? 'ACCOUNT.promotion.flow.step3.moneyDesc' : 'ACCOUNT.promotion.flow.step3.monthsDesc')
              | translate
                : {
                    totalAmount: vm.promo.referralMoneyMoneyMonthly * vm.promo.referralMoneyMonthsDuration | thousand: vm.currency,
                    amount: vm.promo.referralMoneyMoneyMonthly | thousand: vm.currency,
                    months: vm.promo.referralMoneyMonthsDuration ? vm.promo.referralMoneyMonthsDuration : vm.promo.referralMonths
                  }
          }}
        </p>
      </div>
    </div>
  </div>

</div>

<div class="promotion-rewards">
  <h2 class="ds-heading-1">{{ 'ACCOUNT.promotion.rewards.heading' | translate }}</h2>
  <div class="promotion-rewards-content">
    <div class="ds-rows-white">
      <!-- No active rewards -->
      @if (vm.noActiveRewards) {
        <div class="ds-row-white">
          <div class="content promotion-no-rewards">
            <p class="ds-ui-2">
              <strong>{{ 'ACCOUNT.promotion.rewards.active.noRewards' | translate }}</strong>
            </p>
          </div>
        </div>
      }
      <!-- Neon-->
      @if (vm.hasNeonPromotion) {
        <div class="ds-row-white">
          <div class="promo-neon">
            <div>
              <img src="/assets/images/neon.svg" alt="Neon" />
            </div>
            <p class="ds-ui-2">
              <strong>CHF 120</strong>&nbsp;
              <span class="ds-color-core-neutral-6">{{ 'ACCOUNT.promotion.rewards.active.neon' | translate }}</span>
            </p>
          </div>
        </div>
      }
      <!-- Free Months -->
      @if (vm.promo.activeMonths) {
        <div class="ds-row-white">
          <div class="promo-content">
            <div>
              <p class="ds-ui-2">
                <strong>
                  {{ vm.promo.activeMonths }}
                  {{
                    (vm.promo.activeMonths === 1 ? 'ACCOUNT.promotion.rewards.active.singleMonth' : 'ACCOUNT.promotion.rewards.active.months')
                      | translate
                  }}
                </strong>
              </p>
              <p class="ds-ui-2 ds-color-core-neutral-6">{{ 'ACCOUNT.promotion.rewards.active.freeInvesting' | translate }}</p>
            </div>
            <div>
              <app-ds-badge type="success">
                {{ 'ACCOUNT.promotion.rewards.active.status' | translate }}
              </app-ds-badge>
              <app-ds-icon name="info" color="var(--color-core-neutral-5)" (click)="toggleInfo('freeInvestingMonths')"></app-ds-icon>
            </div>
          </div>
          @if (info['freeInvestingMonths']) {
            <div class="info">
              <p class="ds-ui-3">{{ 'ACCOUNT.promotion.rewards.active.freeInvestingMonths' | translate }}</p>
            </div>
          }
        </div>
      }
      <!-- Money reward-->
      @if (vm.promo.activeMoneyMonthly) {
        <div class="ds-row-white">
          <div class="promo-content">
            <div>
              <p class="ds-ui-2">
                <strong>
                  {{ vm.promo.activeMoneyMonthly | thousand: vm.currency }}
                </strong>
              </p>
              <p class="ds-ui-2 ds-color-core-neutral-6">
                {{ 'ACCOUNT.promotion.rewards.active.moneyMonthly' | translate }}
              </p>
            </div>

            <div>
              <app-ds-badge type="success">
                {{ 'ACCOUNT.promotion.rewards.active.status' | translate }}
              </app-ds-badge>
              <app-ds-icon name="info" color="var(--color-core-neutral-5)" (click)="toggleInfo('moneyMonthlyDesc')"></app-ds-icon>
            </div>
          </div>
          @if (info['moneyMonthlyDesc']) {
            <div class="info">
              <p class="ds-ui-3">{{ 'ACCOUNT.promotion.rewards.active.moneyMonthlyDesc' | translate }}</p>
            </div>
          }
        </div>
      }
      <!-- Pending money reward -->
      @if (vm.promo.pendingMoneyOverall) {
        <div class="ds-row-white">
          <div class="promo-content">
            <div>
              <p class="ds-ui-2">
                <strong>
                  {{ vm.promo.pendingMoneyOverall | thousand: vm.currency }}
                </strong>
              </p>
              <p class="ds-ui-2 ds-color-core-neutral-6">
                {{ 'ACCOUNT.promotion.rewards.pending.money' | translate }}
              </p>
            </div>

            <div>
              <app-ds-badge type="warning">
                {{ 'ACCOUNT.promotion.rewards.pending.status' | translate }}
              </app-ds-badge>
              <app-ds-icon name="info" color="var(--color-core-neutral-5)" (click)="toggleInfo('pendingMoney')"></app-ds-icon>
            </div>
          </div>
          @if (info['pendingMoney']) {
            <div class="info">
              <p class="ds-ui-3">{{ 'ACCOUNT.promotion.rewards.pending.desc' | translate }}</p>
            </div>
          }
        </div>
      }
      <!-- Pending months reward -->
      @if (vm.promo.pendingMonths) {
        <div class="ds-row-white">
          <div class="promo-content">
            <div>
              <p class="ds-ui-2">
                <strong>
                  {{ vm.promo.pendingMonths }}
                  {{
                    (vm.promo.pendingMonths === 1 ? 'ACCOUNT.promotion.rewards.active.singleMonth' : 'ACCOUNT.promotion.rewards.active.months')
                      | translate
                  }}
                </strong>
              </p>
              <p class="ds-ui-2 ds-color-core-neutral-6" [innerHTML]="'ACCOUNT.promotion.rewards.pending.months' | translate"></p>
            </div>
            <div>
              <app-ds-badge type="warning">
                {{ 'ACCOUNT.promotion.rewards.pending.status' | translate }}
              </app-ds-badge>
              <app-ds-icon name="info" color="var(--color-core-neutral-5)" (click)="toggleInfo('pendingMonths')"></app-ds-icon>
            </div>
          </div>
          @if (info['pendingMonths']) {
            <div class="info">
              <p class="ds-ui-3">{{ 'ACCOUNT.promotion.rewards.pending.monthsDesc' | translate }}</p>
            </div>
          }
        </div>
      }

      <div class="promotion-rewards-separator"></div>

      <div class="promotion-info">
        <div class="promotion-info-dropdown">
          <div class="promotion-info-btn" (click)="toggleInfo('promotionInfo')">
            <p class="ds-caption-1">{{ 'ACCOUNT.promotion.rewards.how.title' | translate }}</p>
            <app-ds-icon size="icon-size-2" [name]="info['promotionInfo'] ? 'chevron-up' : 'chevron-down'"></app-ds-icon>
          </div>

          @if (info['promotionInfo']) {
            <div class="promotion-info-content">
              <p class="ds-ui-3">{{ 'ACCOUNT.promotion.rewards.how.desc' | translate }}</p>

              @for (item of [1, 2, 3, 4]; track item) {
                <div class="promotion-info-item">
                  <p class="ds-ui-3">
                    <strong>{{ 'ACCOUNT.promotion.rewards.how.step' + item + '.title' | translate }}</strong>
                  </p>
                  <p class="ds-ui-3">{{ 'ACCOUNT.promotion.rewards.how.step' + item + '.desc' | translate }}</p>
                  @if (item === 1) {
                    <ul>
                      <li class="ds-ui-3">{{ 'ACCOUNT.promotion.rewards.how.step1.li1' | translate }}</li>
                      <li class="ds-ui-3">{{ 'ACCOUNT.promotion.rewards.how.step1.li2' | translate }}</li>
                    </ul>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="promotion-qr">
  <h3 class="ds-heading-2">{{ 'ACCOUNT.promotion.invite.qr.heading' | translate }}</h3>
  <div class="ds-card">
    <qrcode [qrdata]="'https://app.inyova.' + vm.appLocation + '/invite/' + vm.referralCode" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
    <div class="promotion-qr-desc">
      <p class="ds-running-3 ds-color-core-neutral-7">{{ 'ACCOUNT.promotion.invite.qr.desc' | translate }}</p>
    </div>
  </div>
</div>
